<template>
  <button
      @click="$emit('click')"
      class="button_component"
      :disabled="loading"
      :class="`
      ${size ? size : ''}
      ${variant ? variant: ''}
      ${thin ? 'thin': ''}
      ${mobileFullWidth ? 'mobileFullWidth': ''}
    `"
      :style="{
      marginLeft: ml,
      marginBottom: mb,
      marginTop: mt,
      maxWidth: width
    }"
  >
    <div style="display: flex;justify-content: center;align-items: center;">
      <slot></slot>
      <div class="lds-ring" v-if="loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'button-component',
  props: {
    loading: Boolean,
    size: {
      type: String,
      default: 'big'
    },
    variant: {
      type: String,
      default: 'outlined'
    },
    ml: String,
    mb: String,
    mt: String,
    thin: Boolean,
    width: String,
    mobileFullWidth: Boolean
  }
}
</script>

<style scoped lang="scss">
.button_component {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #383838;
  width: 100%;
  border-radius: 5px;
  border: none;

  &.thin {
    border: 1px solid #DBBFA7 !important;
    font-weight: 400;
    color: #808080;
  }

  &.small {
    height: 50px;
    max-width: 70px;
  }

  &.big {
    height: 50px;
    max-width: 320px;
  }

  &.outlined {
    border-radius: 5px;
    background-color: #fff;
    border: 2px solid #DBBFA7;
  }

  &.filled {
    background: #DBBFA7;
  }

}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 25px;
  height: 25px;
  margin-left: 20px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  border: 3px solid #383838;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #383838 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 991px) {
  .button_component.mobileFullWidth {
    width: 100%;
    max-width: 100%;
  }
}
</style>
